import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Channels from './components/admin/channels/list.vue'
import Channel from './components/admin/channels/Channel.vue'
import AdminTeam from './components/admin/teams/list.vue'
import AdminTeamMember from './components/admin/teams/Member.vue'
import AdminTeamMemberResolve from './components/admin/teams/Resolve.vue'
import AdminTeamClientView from './components/admin/teams/ReferralClientView.vue'
import AdminTeamClientUpdate from './components/admin/teams/AddNewReferral.vue'
import AdminReferrals from './components/admin/referrals/Main.vue'
import AdminReferralAddNew from './components/admin/referrals/AddNewReferral.vue'
import AdminReferralClientView from './components/admin/referrals/ReferralClientView.vue'


// import Team from './components/teams/add.vue'
// import Users from './components/users/list.vue'
// import User from './components/users/add.vue'

import Dashboard from './components/dashboard/Main.vue'
import Referrals from './components/referrals/Main.vue'
import Teams from './components/teams/Main.vue'
import TeamMember from './components/teams/Member.vue'
import TeamMemberResolve from './components/teams/Resolve.vue'
import TeamClientView from './components/teams/ReferralClientView.vue'
import TeamClientUpdate from './components/teams/AddNewReferral.vue'

import Reports from './components/reports/main.vue'
import Signin from './components/login/signin.vue'
import ReferralAddNew from './components/referrals/AddNewReferral.vue'
import ReferralClientView from './components/referrals/ReferralClientView.vue'

import MyActivity from './components/myactivity/Main.vue'

import Search from './components/search/Main.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    // {
    //   path: '/user-validate-auth',
    //   name: 'user_validate_auth',
    //   component: ValidateUserAuth,
    //     meta: {
    //       requiresAuth: false,
    //       checkAppSession: false
    //     }
    // },
    {
      path: '/signin',
      name: 'signin',
      component: Signin,
      meta: {
        checkAppSession: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/referrals',
      name: 'referrals',
      redirect: '/referrals/valid'
    },
    {
      path: '/search-results/:filter_by',
      name: 'search_results',
      component: Search,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/referrals/add-new',
      name: 'referrals_add_new',
      component: ReferralAddNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/referrals/client/:id',
      name: 'referrals_client_view',
      component: ReferralClientView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/referrals/update/:id',
      name: 'referrals_update_client',
      component: ReferralAddNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/referrals/:status',
      name: 'referral_status',
      component: Referrals,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/teams',
      name: 'teams',
      component: Teams,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/teams/client/:id',
      name: 'teams_client_view',
      component: TeamClientView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/teams/client/update/:id',
      name: 'teams_client_update',
      component: TeamClientUpdate,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/teams/member/:id/resolve/:referral_id',
      name: 'team_member_resolve',
      component: TeamMemberResolve,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/teams/member/:id/:status',
      name: 'team_member',
      component: TeamMember,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/my-activity',
      name: 'my_activity',
      component: MyActivity,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels',
      name: 'admin_channels',
      component: Channels,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels/:id',
      name: 'admin_channel',
      component: Channel,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels/teams/:id',
      name: 'admin_teams',
      component: AdminTeam,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels/teams/:team_id/member/:id/resolve/:referral_id',
      name: 'admin_team_member_resolve',
      component: AdminTeamMemberResolve,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels/teams/:team_id/member/:id/:status',
      name: 'admin_team_member',
      component: AdminTeamMember,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels/teams/:team_id/client/:id',
      name: 'admin_teams_client_view',
      component: AdminTeamClientView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/channels/teams/:team_id/client/update/:id',
      name: 'admin_teams_client_update',
      component: AdminTeamClientUpdate,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/referrals',
      name: 'admin_referrals',
      redirect: '/admin/referrals/valid'
    },
    {
      path: '/admin/referrals/:status',
      name: 'admin_referral_status',
      component: AdminReferrals,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/referrals/client/:id',
      name: 'admin_referrals_client_view',
      component: AdminReferralClientView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/referrals/update/:id',
      name: 'admin_referrals_update_client',
      component: AdminReferralAddNew,
      meta: {
        requiresAuth: true
      }
    }
  ]
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.signedIn) {
      next({ name: 'signin' })
    } else {
      next() // go to wherever I'm going
    }
  } else if (to.matched.some(record => record.meta.checkAppSession)) {
    if (store.state.signedIn) {
      next({ name: 'dashboard' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
